export default __webpack_public_path__ + "static/media/ic-crops-rockmelon.1ae90a10.svg";